<div>
    <table mat-table style="border-radius: 10px;"
    class="mat-elevation-z8"
    multiTemplateDataRows
    [dataSource]="dataSource">
        <ng-container matColumnDef="expandArrow">
            <th mat-header-cell *matHeaderCellDef>
                &nbsp;
            </th>
            <td mat-cell *matCellDef="let element">
                <mat-icon>
                    {{selectedRoleId !== null && selectedRoleId === element.roleId ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}}
                </mat-icon>
            </td>
        </ng-container>

        <ng-container matColumnDef="name">
            <th mat-header-cell
            *matHeaderCellDef>
            Nombre
            </th>
            <td mat-cell *matCellDef="let element">
                <h6>{{ element.name }}</h6>
            </td>
        </ng-container>

        <ng-container matColumnDef="description">
            <th mat-header-cell
            *matHeaderCellDef>
            Descripción
            </th>
            <td mat-cell *matCellDef="let element">
                <h6>{{ element.description }}</h6>
            </td>
        </ng-container>
        
        <ng-container matColumnDef="star" stickyEnd>
            <th mat-header-cell *matHeaderCellDef aria-label="row actions">&nbsp;</th>
            <td mat-cell *matCellDef="let element">
                <button (click)="$event.stopPropagation();" mat-icon-button [matMenuTriggerFor]="menu" [matMenuTriggerData]="{element: element}">
                    <mat-icon>more_vert</mat-icon>
                </button>
            </td>
        </ng-container>

        <ng-container matColumnDef="expandedDetail">
            <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns?.length">
                <div class="example-element-detail"
                [@detailExpand]="selectedRoleId !== null && selectedRoleId === element.roleId ? 'expanded' :'collapsed'">
                <div *ngIf="selectedRoleId === element.roleId">
                    <app-role-detail [roleId]="element.roleId"></app-role-detail>
                </div>
                </div>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" 
        class="example-element-row"
        (click)="toggleExpandableRole(row.roleId)"
        [class.example-expanded-row]="selectedRoleId !== null && selectedRoleId === row.roleId"></tr>
        <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
    </table>
    <br>
    <mat-paginator [pageSizeOptions]="[10, 20]"></mat-paginator>

    <mat-menu #menu>
        <ng-template matMenuContent let-aliasMenuItems="element">
            <button mat-menu-item (click)="openPermissions(aliasMenuItems)">
                Permisos
            </button>
            <button mat-menu-item>
                Editar
            </button>    
        </ng-template>
    </mat-menu>
</div>